/** @format */

import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PayPeriodEntry, PostEntries, TimeentryDB, TimeentryDBByPeriod } from 'src/app/store/application';

@Injectable()
export class EntryService {
	entriesUrl = 'api/entries';

	httpOptions = {
		headers: new HttpHeaders({
			'Cache-Control': 'no-cache',
			Pragma: 'no-cache',
		}),
	};

	constructor(private httpClient: HttpClient) {}

	// getTimeEntries(): Observable<PayPeriodEntry[]> {
	//     return this.httpClient.get<PayPeriodEntry[]>(`${this.entriesUrl}`, this.httpOptions);
	// }

	getTimeEntries(): Observable<TimeentryDB[]> {
		return this.httpClient.get<TimeentryDB[]>(`${this.entriesUrl}`, this.httpOptions);
	}

	postTimeEntries(postEntries: { approvedTimesheetsIds: number[]; timeEntries: TimeentryDB[]; batchNumber: number }): Observable<any> {
		return this.httpClient.post(`${this.entriesUrl}`, postEntries, this.httpOptions);
	}
}
